import { createAction, props } from '@ngrx/store';
import {
  RegistrationFlow,
  SuccessfulNativeRegistration,
  UpdateRegistrationFlowBody,
} from '@ory/client';

export const RequireRegistration = createAction(
  '[Auth] Request Registration',
  props<{ postLoginRoute?: string; query?: any }>()
);
export const AtRegistration = createAction('[Auth] At Registration');

export const RequestBeginRegistrationFlow = createAction(
  '[Auth][Registration][Request] begin flow'
);
export const SuccessBeginRegistrationFlow = createAction(
  '[Auth][Registration][Success] begin flow',
  props<{ flow: RegistrationFlow }>()
);
export const FailBeginRegistrationFlow = createAction(
  '[Auth][Registration][Fail] begin flow',
  props<{ error: any }>()
);

export const RequestCompleteRegistrationFlow = createAction(
  '[Auth][Registration][Request] complete flow',
  props<{ payload: UpdateRegistrationFlowBody }>()
);
export const SuccessCompleteRegistrationFlow = createAction(
  '[Auth][Registration][Success] complete flow',
  props<{ response: SuccessfulNativeRegistration }>()
);

/**
 * Registration errors return a new flow to show to the user
 */
export const FailCompleteRegistrationFlow = createAction(
  '[Auth][Registration][Fail] complete flow',
  props<{ response: RegistrationFlow }>()
);
